import { apiSlice } from '../app/api/apiSlice';

export const configsApi = apiSlice.injectEndpoints({
  endpoints: (builder)=>({
    getConfigs: builder.query({
      query: () => 'config',
      keepUnusedDataFor: 0,
    }),
    editConfigs: builder.mutation({
        query: (editedConfigs) => ({
            url: `config`,
            method: 'PUT',
            body: editedConfigs,
          }),
      keepUnusedDataFor: 0,
    })
})
})

export const { useGetConfigsQuery, useLazyGetConfigsQuery, useEditConfigsMutation } = configsApi;